export { TeamDocsPage } from './Team/TeamDocsPage/TeamDocsPage';
export { TeamEventsPage } from './Team/TeamEventsPage/TeamEventsPage';
export { TeamResearchPage } from './Team/TeamResearchPage/TeamResearchPage';
export { TeamsPage } from './TeamsPage/TeamsPage';
export { TeamParticipantsPage } from './Team/TeamParticipantsPage/TeamParticipantsPage';
export { TeamNewPage } from './Team/TeamNewPage/TeamNewPage';
export { TeamEditPage } from './Team/TeamEditPage/TeamEditPage';
